import React, { Component } from 'react';
import './Profile.css';

import Button from 'react-bootstrap/Button';

class Profile extends Component {

    handleLogout = (event) => {
        event.preventDefault();

        localStorage.clear();

        fetch('logout', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "username=" + this.props.username
        })

        .then(res => res.json())
        .then(data =>
        {
            this.props.isLoggedOut(data[0].username, data[0].accessLevel);
        })
        .catch(console.log)
    }

    handleProfile = (event) => {
        this.props.handleOpenProfile();
    }

    //admin only: the settings gear between the username and the logout button.
    //type="button" so it cannot submit the surrounding logout form.
    renderSettingsGear = () => {

        if (1 !== this.props.accessLevel)
        {
            return null;
        }

        return (
            <button type="button" className="btnSettingsGear" aria-label="Settings" title="Settings" onClick={this.props.showSettings}>
                <svg width="30" height="30" viewBox="0 0 16 16" aria-hidden="true">
                    <path d="M8 1.2 l1 1.8 a5.3 5.3 0 0 1 1.6 0.66 l2 -0.6 1 1.73 -1.44 1.5 a5.3 5.3 0 0 1 0 1.42 l1.44 1.5 -1 1.73 -2 -0.6 a5.3 5.3 0 0 1 -1.6 0.66 l-1 1.8 -2 0 -0.55 -2 a5.3 5.3 0 0 1 -1.38 -0.57 l-2 0.6 -1 -1.73 1.44 -1.5 a5.3 5.3 0 0 1 0 -1.42 l-1.44 -1.5 1 -1.73 2 0.6 a5.3 5.3 0 0 1 1.38 -0.57 l0.55 -2 z"
                          fill="none" stroke="#FFFFFF" strokeWidth="1.2" strokeLinejoin="round" transform="translate(0.5 0.4)" />
                    <circle cx="8" cy="8" r="2.1" fill="none" stroke="#FFFFFF" strokeWidth="1.2" />
                </svg>
            </button>
        );
    }

    render() {
        return (<div class="introWidth">
                    <form class="form-inline" name="frmLogout" onSubmit={this.handleLogout}><h2 class="title">Welcome</h2> <h2 class="userProfile" onClick={this.handleProfile}>{this.props.username}</h2>{this.renderSettingsGear()}<Button className="btnProfile" size="sm" type="submit">Logout</Button></form>
                </div>);
    }
}

export default Profile;

